export default {
  path: 'salesContracts',
  meta: {
    title: '采销合同'
  },
  component: () => import('@/components/parent-view'),
  name: 'salesContracts',
  children: [
    {
      path: 'list',
      meta: {
        title: '采销合同列表'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          meta: {
            title: '采销合同列表',
            ignoreBreadCrumb: true
          },
          name: 'self-contracts-list',
          component: () => import('@/view/v5/salesContracts/list/index.vue')
        },
        {
          path: 'edit',
          meta: {
            title: '采销合同列表编辑',
            hideInTabBar: true,
            edit: true,
            pending: true
          },
          name: 'self-contracts-edit',
          component: () => import('@/view/v5/salesContracts/list/edit.vue')
        },
      ]
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/routes/v5/salesContracts.js